/* Carousel.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["displayCarousel"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["displayCarousel"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["active"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["transitionTimerInMs"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["displayCarousel"],
  _excluded12 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _51 = "._1ygbi70q:focus-visible{outline:var(--_wdxe65)}";
const _50 = "._4t3ixy5q{height:var(--ds-space-400,2pc)}";
const _49 = "._1bsbxy5q{width:var(--ds-space-400,2pc)}";
const _48 = "._lcxv1rj4{pointer-events:all}";
const _47 = "._19it1eso{border:var(--_1m4nn1n)}";
const _46 = "._11q71bhr{background:var(--ds-surface-overlay,#fff)}";
const _45 = "._zulp13he{gap:var(--ds-space-100,.625rem)}";
const _44 = "._1yt4u2gc{padding:var(--ds-space-100,8px)}";
const _43 = "._i0dl1osq{flex-basis:100%}";
const _42 = "._1o9zidpf{flex-shrink:0}";
const _41 = "._16jlidpf{flex-grow:0}";
const _40 = "._18m9ewfl{overflow-y:visible}";
const _39 = "._1reoewfl{overflow-x:visible}";
const _38 = "._18m915vq{overflow-y:hidden}";
const _37 = "._1reo15vq{overflow-x:hidden}";
const _36 = "._1bsb1osq{width:100%}";
const _35 = "._kqswh2mm{position:relative}";
const _34 = "._v5641m16{transition:var(--_vz31bp)}";
const _33 = "@media not all and (min-width:48rem){._sugaglyw{display:none}}";
const _32 = "._1pbycs5v{z-index:2}";
const _31 = "._lcxvglyw{pointer-events:none}";
const _30 = "._1xi2idpf{right:0}";
const _29 = "._94n5idpf{bottom:0}";
const _28 = "._kqswstnw{position:absolute}";
const _27 = "._4t3i1osq{height:100%}";
const _26 = "._1bsbdjo9{width:calc(100% - var(--ds-space-200, 1pc)*2)}";
const _25 = "._1bah1yb4{justify-content:space-between}";
const _24 = "._4cvr1h6o{align-items:center}";
const _23 = "._18s8119w{margin:0 var(--ds-space-200,1pc)}";
const _22 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _21 = "._bfhk1oju{background-color:var(--ds-icon-subtle,#626f86)}";
const _20 = "._bfhk1qo3{background-color:var(--ds-icon-selected,#0c66e4)}";
const _19 = "._1e0c1o8l{display:inline-block}";
const _18 = "._80omtlke{cursor:pointer}";
const _17 = "._4t3iu2gc{height:var(--ds-space-100,8px)}";
const _16 = "._1bsbu2gc{width:var(--ds-space-100,8px)}";
const _15 = "._19itglyw{border:none}";
const _14 = "._19bvidpf{padding-left:0}";
const _13 = "._n3tdidpf{padding-bottom:0}";
const _12 = "._u5f3idpf{padding-right:0}";
const _11 = "._ca0qidpf{padding-top:0}";
const _10 = "._18s8otz2{margin:0 var(--ds-space-050,4px)}";
const _9 = "._2rko1ssb{border-radius:50%}";
const _8 = "._1e0cglyw{display:none}";
const _7 = "._1e0c1txw{display:flex}";
const _6 = "._19pk1ejb{margin-top:var(--ds-space-300,24px)}";
const _5 = "._1bah1h6o{justify-content:center}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import ChevronLeftIcon from '@atlaskit/icon/utility/chevron-left';
import ChevronRightIcon from '@atlaskit/icon/utility/chevron-right';
import { media } from '@atlaskit/primitives/responsive';
import { ACTION_SUBJECT_ID_DOT, ACTION_SUBJECT_ID_NEXT_BUTTON, ACTION_SUBJECT_ID_PREV_BUTTON, ACTION_SUBJECT_ID_SLIDE, ACTION_SUBJECT_ID_SWIPE_LEFT, ACTION_SUBJECT_ID_SWIPE_RIGHT, CarouselClickEvent, CarouselSlideViewEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "@media (min-width:64rem){._zp81ewfl{overflow-x:visible}._1mbpewfl{overflow-y:visible}}";
const _3 = "@media (min-width:64rem){._zp8115vq{overflow-x:hidden}._1mbp15vq{overflow-y:hidden}}";
const _2 = "@media (min-width:64rem){}";
const SLIDE_TRANSITION_TIME_IN_MS = 300;
export const CarouselContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      displayCarousel
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["", __cmplp.displayCarousel ? "_zp8115vq _1mbp15vq" : "_zp81ewfl _1mbpewfl", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CarouselContainer.displayName = 'CarouselContainer';
}
export const PaginationDots = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  const {
      displayCarousel
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bah1h6o _19pk1ejb", __cmplp.displayCarousel ? "_1e0c1txw" : "_1e0cglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PaginationDots.displayName = 'PaginationDots';
}
export const Dot = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded5);
  const {
      active
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rko1ssb _18s8otz2 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _1bsbu2gc _4t3iu2gc _80omtlke _1e0c1o8l", __cmplp.active ? "_bfhk1qo3" : "_bfhk1oju", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Dot.displayName = 'Dot';
}
export const ArrowsContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_22, _23, _7, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpu2gc _18s8119w _1e0c1txw _4cvr1h6o _1bah1yb4 _1bsbdjo9 _4t3i1osq _kqswstnw _94n5idpf _1xi2idpf _lcxvglyw _1pbycs5v _sugaglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ArrowsContainer.displayName = 'ArrowsContainer';
}
const ArrowButtonStyle = null;
const CardsWrapper = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded8);
  const {
      transitionTimerInMs
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_34, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_vz31bp": ix("transform ".concat(__cmplp.transitionTimerInMs, "ms ease-in-out"))
      }),
      ref: __cmplr,
      className: ax(["_v5641m16 _1e0c1txw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CardsWrapper.displayName = 'CardsWrapper';
}
const CarouselContainerStyle = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded10);
  const {
      displayCarousel
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_35, _36, _37, _38, _39, _40]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kqswh2mm _1bsb1osq", __cmplp.displayCarousel ? "_1reo15vq _18m915vq" : "_1reoewfl _18m9ewfl", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CarouselContainerStyle.displayName = 'CarouselContainerStyle';
}
const CardContainerStyle = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_41, _42, _43]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlidpf _1o9zidpf _i0dl1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CardContainerStyle.displayName = 'CardContainerStyle';
}
export const useCarouselNavigation = (itemsLength, itemsPerSection, transitionTimerInMs) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [transitioning, setTransitioning] = useState(false);
  const totalSections = Math.ceil(itemsLength / itemsPerSection);
  const isLastSection = currentIndex === totalSections - 1;
  const fireEvent = useAnalyticsEvents();
  const handleSlideChange = useCallback((newIndex, actionSubject) => {
    fireEvent({
      eventType: CarouselClickEvent,
      actionSubjectId: actionSubject,
      attributes: {
        currentIndex,
        newIndex,
        itemsLength
      }
    });
    setCurrentIndex(newIndex);
    setTransitioning(true);
    setTimeout(() => {
      setTransitioning(false);
    }, transitionTimerInMs);
  }, [transitionTimerInMs, currentIndex, fireEvent]);
  const handlePrev = useCallback(actionSubject => {
    const newIndex = currentIndex === 0 ? totalSections - 1 : currentIndex - 1;
    handleSlideChange(newIndex, actionSubject !== null && actionSubject !== void 0 ? actionSubject : ACTION_SUBJECT_ID_PREV_BUTTON);
  }, [currentIndex, handleSlideChange, totalSections]);
  const handleNext = useCallback(actionSubject => {
    const newIndex = currentIndex === totalSections - 1 ? 0 : currentIndex + 1;
    handleSlideChange(newIndex, actionSubject !== null && actionSubject !== void 0 ? actionSubject : ACTION_SUBJECT_ID_NEXT_BUTTON);
  }, [currentIndex, handleSlideChange, totalSections]);
  return {
    currentIndex,
    itemsPerSection,
    handleSlideChange,
    totalSections,
    isLastSection,
    handlePrev,
    handleNext,
    transitioning
  };
};
export function useSwipe(onSwipeLeft, onSwipeRight) {
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const minSwipeDistance = 50;
  const onTouchStart = e => {
    touchEndX.current = null;
    touchStartX.current = e.targetTouches[0].clientX;
  };
  const onTouchMove = e => {
    touchEndX.current = e.targetTouches[0].clientX;
  };
  const onTouchEnd = () => {
    if (touchStartX.current !== null && touchEndX.current !== null && Math.abs(touchStartX.current - touchEndX.current) > minSwipeDistance) {
      if (touchStartX.current > touchEndX.current) {
        onSwipeLeft(ACTION_SUBJECT_ID_SWIPE_LEFT);
      } else {
        onSwipeRight(ACTION_SUBJECT_ID_SWIPE_RIGHT);
      }
    }
  };
  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd
  };
}
export const Carousel = _ref8 => {
  let {
    children,
    itemsPerSection,
    slideTransitionTimeInMs = SLIDE_TRANSITION_TIME_IN_MS
  } = _ref8;
  const items = React.Children.toArray(children);
  const displayCarousel = items.length > 1;
  const transitionTimerInMs = slideTransitionTimeInMs || SLIDE_TRANSITION_TIME_IN_MS;
  const {
    currentIndex,
    handleSlideChange,
    handlePrev,
    handleNext,
    transitioning
  } = useCarouselNavigation(items.length, itemsPerSection, transitionTimerInMs);
  const fireEvent = useAnalyticsEvents();
  const viewedSlides = useRef(new Set());
  const swipeHandlers = useSwipe(handleNext, handlePrev);
  useEffect(() => {
    if (!transitioning && !viewedSlides.current.has(currentIndex)) {
      fireEvent({
        eventType: CarouselSlideViewEvent,
        actionSubjectId: ACTION_SUBJECT_ID_SLIDE,
        attributes: {
          slideIndex: currentIndex,
          totalSlides: items.length
        }
      });
      viewedSlides.current.add(currentIndex);
    }
  }, [currentIndex, transitioning, items.length, itemsPerSection, fireEvent]);
  return /*#__PURE__*/_jsxs(CarouselContainerStyle, _objectSpread(_objectSpread({
    displayCarousel: displayCarousel
  }, swipeHandlers), {}, {
    "data-testid": "carousel-container",
    children: [displayCarousel && /*#__PURE__*/_jsxs(ArrowsContainer, {
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_44, _45, _46, _9, _47, _48, _49, _50, _18, _51]
        }), /*#__PURE__*/_jsx("button", {
          onClick: () => handlePrev(ACTION_SUBJECT_ID_PREV_BUTTON),
          className: ax(["_1yt4u2gc _zulp13he _11q71bhr _2rko1ssb _19it1eso _lcxv1rj4 _1bsbxy5q _4t3ixy5q _80omtlke _1ygbi70q"]),
          style: {
            "--_1m4nn1n": ix("0.0625rem solid ".concat("var(--ds-border-bold, #758195)")),
            "--_wdxe65": ix("0.0625rem solid ".concat("var(--ds-border-focused, #388BFF)"))
          },
          children: /*#__PURE__*/_jsx(ChevronLeftIcon, {
            label: "Previous section"
          })
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_44, _45, _46, _9, _47, _48, _49, _50, _18, _51]
        }), /*#__PURE__*/_jsx("button", {
          onClick: () => handleNext(ACTION_SUBJECT_ID_NEXT_BUTTON),
          className: ax(["_1yt4u2gc _zulp13he _11q71bhr _2rko1ssb _19it1eso _lcxv1rj4 _1bsbxy5q _4t3ixy5q _80omtlke _1ygbi70q"]),
          style: {
            "--_1m4nn1n": ix("0.0625rem solid ".concat("var(--ds-border-bold, #758195)")),
            "--_wdxe65": ix("0.0625rem solid ".concat("var(--ds-border-focused, #388BFF)"))
          },
          children: /*#__PURE__*/_jsx(ChevronRightIcon, {
            label: "Next section"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(CardsWrapper, {
      transitionTimerInMs: transitionTimerInMs,
      displayCarousel: displayCarousel,
      currentIndex: currentIndex,
      itemsPerSection: itemsPerSection,
      style: {
        transform: "translateX(-".concat(currentIndex * 100, "%)")
      },
      children: items.map((child, index) => /*#__PURE__*/_jsx(CardContainerStyle, {
        style: {
          visibility: index == currentIndex || transitioning ? 'visible' : 'hidden'
        },
        children: child
      }, index))
    }), /*#__PURE__*/_jsx(PaginationDots, {
      displayCarousel: displayCarousel,
      children: Array.from({
        length: items.length
      }).map((_, index) => /*#__PURE__*/_jsx(Dot, {
        tabIndex: -1,
        active: index === currentIndex,
        onClick: () => handleSlideChange(index, ACTION_SUBJECT_ID_DOT)
      }, index))
    })]
  }));
};